import { render, staticRenderFns } from "./403.vue?vue&type=template&id=0c721e22&scoped=true&"
import script from "./403.vue?vue&type=script&lang=ts&"
export * from "./403.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c721e22",
  null
  
)

export default component.exports